import * as yup from 'yup';

const schema = yup.object().shape({
  porttype: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535)
});

export default schema;
